import { Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { FileUploadDropDown } from 'src/components/FormikComponents';
import MainCard from 'src/components/MainCard/MainCard';
import { BUSINESS_TYPES } from 'src/constants';
import { isIreland } from 'src/lib/countryConfig';

const b1FormTypes = [{ key: 'B1_FORM', value: 'B1 Form' }];

const businessReportTypes = [{ key: 'BUSINESS_REPORT', value: 'Business Report' }];

const otherTypes = [{ key: 'OTHER', value: 'Other' }];

const ExtraSupportingDocuments = ({ businessType, acceptedFilesToUpload, isEditingDisabled }) => {
    return (
        <MainCard>
            <Typography fontSize="24px" color="#1D1D1B" marginBottom="8px">
                Supporting Documents
            </Typography>
            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '34px',
                }}
            />
            <Grid container rowSpacing={2} columnSpacing={2} rowGap={2}>
                {isIreland && (
                    <>
                        {!(
                            businessType === BUSINESS_TYPES.SOLE_TRADER ||
                            businessType === BUSINESS_TYPES.PARTNERSHIP
                        ) && (
                            <Grid item xs={12} md={6}>
                                <FileUploadDropDown
                                    name="b1FormFile"
                                    fileTypes={b1FormTypes.map(({ key, value }) => {
                                        return {
                                            value,
                                            label: key,
                                        };
                                    })}
                                    acceptedFileTypes={acceptedFilesToUpload}
                                    label="B1 Form"
                                    placeholder="B1 Form"
                                    isReadOnly={isEditingDisabled}
                                />
                            </Grid>
                        )}
                        {!(businessType === BUSINESS_TYPES.SOLE_TRADER) ? (
                            <Grid item xs={12} md={6}>
                                <FileUploadDropDown
                                    name="businessReportFile"
                                    fileTypes={businessReportTypes.map(({ key, value }) => {
                                        return {
                                            value,
                                            label: key,
                                        };
                                    })}
                                    acceptedFileTypes={acceptedFilesToUpload}
                                    label="Business Report"
                                    placeholder="Business Report"
                                    isReadOnly={isEditingDisabled}
                                />
                            </Grid>
                        ) : null}
                    </>
                )}
                <Grid item xs={12} md={6}>
                    <FileUploadDropDown
                        name="otherFile"
                        fileTypes={otherTypes.map(({ key, value }) => {
                            return {
                                value,
                                label: key,
                            };
                        })}
                        acceptedFileTypes={acceptedFilesToUpload}
                        label="Other"
                        placeholder="Other"
                        isReadOnly={isEditingDisabled}
                    />
                </Grid>
            </Grid>
        </MainCard>
    );
};

ExtraSupportingDocuments.propTypes = {
    businessType: PropTypes.string.isRequired,
    acceptedFilesToUpload: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
    isEditingDisabled: PropTypes.bool.isRequired,
};

export default ExtraSupportingDocuments;
